
import { FC } from "react";
import { AuthenticatedLayout } from "../../layouts";
import { GeneralSettingsList } from "../../components/GeneralSettingsList";

export interface IGeneralSettingsListPage {}

export const GeneralSettingsListPage: FC<IGeneralSettingsListPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="General Settings List"
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "General Settings", navigateTo: "/settings/general/list" },
      ]}
      mainContents={<GeneralSettingsList />}
    />
  );
};
